import { ChartOfAccountId } from '@modules-deprecated/app/organization/enums/chartOfAccountId'
import { CompanyType } from '@modules-deprecated/app/organization/enums/companyType'
import type { Organization } from '@modules-deprecated/app/organization/types/organization'

type CanMarkBankLineAsPrivateOrganization = Pick<Organization, 'chartOfAccountId' | 'countryId'> & {
  companyType?: Organization['companyType'] | ''
}

export const canMarkBankLineAsPrivate = (organization?: CanMarkBankLineAsPrivateOrganization): boolean => {
  if (!organization) {
    return false
  }

  const isManualChartOfAccounts = organization.chartOfAccountId === ChartOfAccountId.Manual
  const isDanishOrganization = organization.countryId === 'DK'
  const isProprietorship = organization.companyType === CompanyType.Proprietorship

  return !isManualChartOfAccounts && (!isDanishOrganization || isProprietorship)
}
